module.exports = __webpack_public_path__ + "static/buildingproducts_icon-9db95e504c81053e3109a047718faad1.svg";